import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdhocInvoiceService } from '../shared/adhoc-invoice.service';
import { CustomerProfileService } from 'src/app/shared/services/customer-profile.service';
import { CommonService } from 'src/app/shared/services/common.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-adhoc-cvv-payment',
  templateUrl: './adhoc-cvv-payment.component.html',
  styleUrls: ['./adhoc-cvv-payment.component.scss']
})
export class AdhocCvvPaymentComponent implements OnInit {
  formDataWithCVV: FormGroup;
  expiryDate:any;
  cardDetails:any;
    @Output() paymentSuccess = new EventEmitter<void>();
  
  creditCarddetail = {
    cardNumber: '',
    cardType: ''
    };
    profileId:any;
    paymentProfileId:any;
  invoiceDataSubscription: any;
  invoiceEmittedData: any;
  constructor(
    private fb: FormBuilder ,
    private adhocInvoiceService:AdhocInvoiceService,
    private customerProfileService:CustomerProfileService,
    private commonService:CommonService) {}

  private showPaymentModal(type: 'success' | 'cancel', message: string): void {
    const isSuccess = type === 'success';
    Swal.fire({
      icon: isSuccess ? 'success' : 'error',
      title: isSuccess ? 'Success' : 'Cancelled',
      text: message,
      confirmButtonText: 'OK',
    });
  }

  private extractErrorMessage(source: any, fallback: string): string {
    if (!source) return fallback;
    if (typeof source === 'string') return source;
    if (typeof source?.error === 'string') return source.error;
    if (typeof source?.error?.message === 'string') return source.error.message;
    if (typeof source?.error?.error === 'string') return source.error.error;
    if (typeof source?.error?.error?.message === 'string') return source.error.error.message;
    if (typeof source?.message === 'string') return source.message;
    if (typeof source?.msg === 'string') return source.msg;
    return fallback;
  }

 async ngOnInit() {
    this.initializeForm();
    await this.getEmittedData();
    this.getCustomerSubscription();

  }
  getEmittedData(){
    this.invoiceDataSubscription =  this.adhocInvoiceService.invoiceObservable$.subscribe((data) => {
      if (data) {
        console.log('Received invoice data:', data);
        this.invoiceEmittedData = data;
        console.log('invoiceEmittedData: ', this.invoiceEmittedData);
      } else {
        console.log('No invoice data received yet.');
      }
    });
  }
  isExistingCardType(cardType: string): boolean {
    return this.creditCarddetail?.cardType === cardType;
  }
  // Initialize the form
  private initializeForm(): void {
    this.formDataWithCVV = this.fb.group({
      cardCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
    });
  }
  get cardCode(): string {
    return this.formDataWithCVV?.get('cardCode')?.value;
  }

  // Mock method to provide a dummy card number
  private mockCreditCardDetails(): void {
    // this.creditCarddetail = {
    //   cardNumber: '**** **** **** 1234', // Masked card number for security
    // };
  }

  // Check if the given card type is valid
  // isExistingCardType(cardType: string): boolean {
  //   const validCardTypes = ['MasterCard', 'Amex', 'Visa'];
  //   return validCardTypes.includes(cardType);
  // }

  async getCustomerSubscription(){
    try {
      let data={
        customerId: this.invoiceEmittedData?.data?.customer_id,
        single:true
      }
      const response:any= await this.customerProfileService.getCustomerSubscription(data)
      if(response?.Status){
        this.profileId=response?.data?.data[0]?.ProfileId
        this.paymentProfileId=response?.data?.data[0]?.PaymentProfileId
        this.getCustomerPaymentSubscription()
      }else{
        this.showPaymentModal('cancel', this.extractErrorMessage(response, 'Failed to load customer subscription.'));
      }
    } catch (error) {
      console.log(error);
      this.showPaymentModal('cancel', this.extractErrorMessage(error, 'Failed to load customer subscription.'));
    }
  }

  async getCustomerPaymentSubscription(){
    try {
      let data={
        profileId:this.profileId,
        paymentProfileId:this.paymentProfileId,
        customerId: this.invoiceEmittedData?.data?.customer_id
      }
      const res:any = await this.adhocInvoiceService.getCustomerPaymentProfile(data)
      if(res?.Status){
        this.creditCarddetail.cardNumber=res?.data?.payment?.creditCard?.cardNumber;
        this.creditCarddetail.cardType=res?.data?.payment?.creditCard?.cardType;
        this.expiryDate = res?.data?.payment?.creditCard?.expirationDate
        this.commonService.loader=false;
        this.cardDetails= res;
      }else{
        this.showPaymentModal('cancel', this.extractErrorMessage(res, 'Failed to load payment profile.'));
        this.commonService.loader=false
      }
    } catch (error) {
      console.log(error);
      this.showPaymentModal('cancel', this.extractErrorMessage(error, 'Failed to load payment profile.'));
      this.commonService.loader=false
    }
  }

  markAllAsTouched(): boolean {
    Object.keys(this.formDataWithCVV.controls).forEach(field => {
      const control = this.formDataWithCVV.get(field);
      if (control) {
        control.markAsTouched({ onlySelf: true });
      }
    });
    return this.formDataWithCVV.valid;
  }
  getFullBillingAddress(): string {
    const address1 = this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.address1 || '';
    const address2 = this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.address2 || '';
    const city = this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.city || '';
    const state = this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.state || '';
    const zipCode = this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.zipCode || '';
  
    return [address1, address2, city, state, zipCode]
      .filter(Boolean) // Filter out any empty or undefined values
      .join(', '); // Concatenate with a comma and space
  }
  private formatMonth(month: number): string {
    return month < 10 ? `0${month}` : `${month}`;
  }
  async onSubmitWithCVV() {
    try {
      if(this.markAllAsTouched()){
        const formattedMonth = this.formatMonth(this.expiryDate.value);

        // Map invoice types properly
        const invoiceTypeMapping: { [key: string]: string } = {
          'Plan Change': 'planChange',
          'PlanChange': 'planChange',
          'Plan Renewal': 'renewal',
          'PlanRenewal': 'renewal',
          'Equipment': 'equipment',
          'DevicePurchase': 'equipment',
          'Custom': 'custom',
          'ESM': 'ESIM',
          'ESIM': 'ESIM',
          'invoice': 'renewal' // Default for regular invoices
        };

        const mappedInvoiceType = invoiceTypeMapping[this.invoiceEmittedData?.invoiceType] || this.invoiceEmittedData?.invoiceType || '';

        const payload = {
          customerId: this.invoiceEmittedData?.data?.customer_id,
          invoiceId: this.invoiceEmittedData?.data?.id || null,
          invoiceType: mappedInvoiceType,
          chargeFrom: "profile",
          // creditCard: {
          //   cardNumber: this.creditCarddetail.cardNumber,
          //   expirationDate: this.expiryDate,
          //   cardCode: this.cardCode,
          //   nameOnCard: this.cardDetails?.data?.billTo?.firstName + ' ' + this.cardDetails?.data?.billTo?.lastName,
          //   cardZipCode: this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.zipCode || '',
          //   cardBillingAddress: this.getFullBillingAddress(), // Concatenated address
          //   cardState: this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.state || '',
          //   cardCity: this.invoiceEmittedData?.customerData?.personalInfo?.mailingAddress?.value?.city || '',
          // },
        };
        console.log('billing address: ', this.getFullBillingAddress());

         // Check if `address1` exists in the form, then update the billing address
  
        const response:any = await this.adhocInvoiceService.doAdhocInvoicePayment(payload);
      if(response){
        this.paymentSuccess.emit(); 
        this.onPaymentSuccess(response);
      }
        console.log('payload: ', payload);
        
      }else{
        this.showPaymentModal('cancel', 'Fill all the required fields');
      }
    } catch (error) {
      if(this.markAllAsTouched()){
      this.showPaymentModal(
        'cancel',
        this.extractErrorMessage(error, 'An Unexpected error occured.')
      );
      }
    } finally {
    }
  }

  onPaymentSuccess(response:any){
    if (response?.Status) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Adhoc Payment Status",
        html: `Adhoc Number ${this.invoiceEmittedData?.data?.number} paid successfully`,
        timer: 10000, 
        showConfirmButton: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading(); 
          const closeButton = document.createElement("button");
          closeButton.innerHTML = "&times;";
          closeButton.classList.add("swal2-close");
          closeButton.style.position = "absolute";
          closeButton.style.top = "10px";
          closeButton.style.right = "10px";
          closeButton.style.fontSize = "1.5rem";
          closeButton.style.background = "none";
          closeButton.style.border = "none";
          closeButton.style.cursor = "pointer";

          closeButton.onclick = () => {
            Swal.close();
          };

          Swal.getHtmlContainer()?.appendChild(closeButton);
          const swalTimer = document.getElementById("swal-timer");
          let timerInterval = setInterval(() => {
            let currentTime = parseInt(swalTimer?.innerText || "10");
            if (currentTime > 1) {
              swalTimer!.innerText = (currentTime - 1).toString();
            } else {
              clearInterval(timerInterval);
            }
          }, 1000);
        },
      });
    } else if (!response?.Status || response?.exception) {
      const errorMessage = this.extractErrorMessage(response, 'Adhoc payment failed.');
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Adhoc Payment Status",
        html:`Adhoc Number ${this.invoiceEmittedData?.data?.number} payment failed<br>${errorMessage}`,
        timer: 5000, 
        showConfirmButton: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading(); 
          const closeButton = document.createElement("button");
          closeButton.innerHTML = "&times;";
          closeButton.classList.add("swal2-close");
          closeButton.style.position = "absolute";
          closeButton.style.top = "10px";
          closeButton.style.right = "10px";
          closeButton.style.fontSize = "1.5rem";
          closeButton.style.background = "none";
          closeButton.style.border = "none";
          closeButton.style.cursor = "pointer";

          closeButton.onclick = () => {
            Swal.close();
          };

          Swal.getHtmlContainer()?.appendChild(closeButton);
          const swalTimer = document.getElementById("swal-timer");
          let timerInterval = setInterval(() => {
            let currentTime = parseInt(swalTimer?.innerText || "10");
            if (currentTime > 1) {
              swalTimer!.innerText = (currentTime - 1).toString();
            } else {
              clearInterval(timerInterval);
            }
          }, 1000);
        },
      });
    }
  }
}
